import { useEffect, useRef } from "react";
import { useSceneStore } from "../store/sceneStore";
import { saveSceneToIndexedDb } from "../store/persistence";

const DEBOUNCE_MS = 800;

/** Autosaves the scene (objects + settings) to IndexedDB shortly after any change. */
export function useAutosave() {
  const timeoutRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    const unsubscribe = useSceneStore.subscribe((state) => {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        saveSceneToIndexedDb(state.objects, state.settings);
      }, DEBOUNCE_MS);
    });
    return () => {
      unsubscribe();
      window.clearTimeout(timeoutRef.current);
    };
  }, []);
}
